import clsx from "clsx";

const Container = ({
  as: Comp = "div",
  className = "",
  children,
  slice = {},
  paddingX = true,
  maxWidth = 1280,
}) => {
  const paddingXStyles = "px-[20px] md:px-[40px] xl:px-[80px]";
  return (
    <Comp
      className={clsx({
        [paddingXStyles]: paddingX,
        "pt-0": slice?.primary?.top_padding === "None",
        "pb-0": slice?.primary?.bottom_padding === "None",
        "pt-[20px] md:pt-[40px] xl:pt-[60px]":
          slice?.primary?.top_padding === "Half",
        "pb-[20px] md:pb-[40px] xl:pb-[60px]":
          slice?.primary?.bottom_padding === "Half",
        "pt-[40px] md:pt-[80px] xl:pt-[120px]":
          slice?.primary?.top_padding === "Full",
        "pb-[40px] md:pb-[80px] xl:pb-[120px]":
          slice?.primary?.bottom_padding === "Full",
        [className]: true,
      })}
    >
      <div
        className={`mx-auto h-full w-full`}
        style={{ maxWidth: `${maxWidth}px` }}
      >
        {children}
      </div>
    </Comp>
  );
};

export default Container;
